import React from 'react';
import CheckmarkIcon from '../../assets/icons/CheckmarkIcon';
import InfoIcon from '../../assets/logo/InfoIcon';
import WarningIcon from '../../assets/logo/WarningIcon';
import { FeedbackLabelInterface } from '../../services/exports/Interfaces';
import Theme from '../Theme';
import classnames from 'classnames';

export default function FeedbackLabel(props: FeedbackLabelInterface) {
  const { message, type, errors, hideIcon, className, textClassname } = props;

  function getIcon() {
    if (hideIcon) {
      return null;
    }

    switch (type) {
      case 'Success':
        return (
          <div className="bg-primary rounded-full flex justify-center items-center w-5 h-5">
            <CheckmarkIcon color={Theme.color.white['100']} className="h-2 w-2" />
          </div>
        );
      case 'Error':
        return <WarningIcon color={Theme.color.white.DEFAULT} />;
      case 'Info':
        return <InfoIcon color={Theme.color.gray['300']} fill />;
      case 'Warning':
        return <InfoIcon color={Theme.color.black.DEFAULT} fill />;
      case 'Notice':
        return <InfoIcon color={Theme.color.black.DEFAULT} fill />;
    }
  }

  function getBackgroundColor() {
    switch (type) {
      case 'Success':
        return Theme.color.green['300'];
      case 'Error':
        return Theme.color.danger;
      case 'Info':
        return Theme.color.gray['100'];
      case 'Warning':
        return Theme.color.warning;
      case 'Notice':
        return Theme.color.notice;
    }
  }

  function getLabelColor() {
    switch (type) {
      case 'Success':
        return Theme.color.primary;
      case 'Error':
        return Theme.color.white.DEFAULT;
      case 'Info':
        return Theme.color.gray['300'];
      case 'Warning':
        return Theme.color.black.DEFAULT;
    }
  }

  return (
    <div className={classnames(container, className)} style={{ backgroundColor: getBackgroundColor() }}>
      {getIcon() && <div className="mr-xs">{getIcon()}</div>}
      <p className={classnames('text-sm', textClassname)} style={{ color: getLabelColor() }}>
        {message}
      </p>
      {errors &&
        Object.values(errors)?.map(
          (error) =>
            error && (
              <div key={`error-${error}`}>
                <p>•{error}</p>
              </div>
            ),
        )}
    </div>
  );
}

const container = 'flex flex-row px-sm py-xs rounded items-center';
